export default __webpack_public_path__ + "static/media/passiveIncome.7b7bfff3.webp";